import { Link } from 'react-router-dom';
import { categoryLabel } from '../../data/categories';
import { getRelatedArticles } from '../../lib/content';
import { articlePath } from '../../lib/routes';
import type { Profile } from '../../types/profile';

export function RelatedArticles({ profile, ids }: { profile: Profile; ids?: string[] }) {
  const related = getRelatedArticles(profile, ids);
  if (!related.length) return null;

  return (
    <section className="related-articles" aria-labelledby="related-heading">
      <h2 id="related-heading">Veja também</h2>
      <div className="related-grid">
        {related.map((article) => (
          <Link key={article.meta.id} className="related-card" to={articlePath(profile, article.meta.category, article.meta.slug)}>
            <span>{categoryLabel(article.meta.category)}</span>
            <strong>{article.meta.title}</strong>
          </Link>
        ))}
      </div>
    </section>
  );
}
